function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 209.4 117.3",
    style: {
      enableBackground: "new 0 0 209.4 117.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M175.8,115.1c-3.9,0-7-3.1-7-7v-9.2H41.1v9.2c0,3.9-3.1,7-7,7s-7-3.1-7-7v-9.2h-4.7 c-11.2,0-20.3-9-20.3-20.2V46.6c0.1-3.4,1-6.6,2.6-9.5c3.5-6,10-9.8,16.9-9.8c1.9,0,3.7,0.3,5.5,0.8v-4.1 C27.2,11.7,37.3,1.6,49.7,1.6h110.5c12.3,0,22.4,10,22.6,22.3l0,4.1c1.8-0.5,3.6-0.8,5.5-0.8c10.7,0,19.5,8.7,19.5,19.4v32.2 c-0.1,11.1-9.1,20.2-20.3,20.2h-4.8v9.2C182.8,112,179.6,115.1,175.8,115.1z M21.6,41.1c-3,0-5.5,2.5-5.5,5.5v32.2 c0.1,3.4,2.9,6.2,6.3,6.2h165c3.4,0,6.3-2.8,6.3-6.2l0-32.1c0-3-2.5-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5v20.3c0,3.9-3.1,7-7,7H34.1 c-3.9,0-7-3.1-7-7V46.6C27.1,43.6,24.6,41.1,21.6,41.1z M168.8,59.9V24.1c0-4.7-3.9-8.5-8.6-8.5h-48.3v44.3H168.8z M97.9,59.9V15.6 H49.7c-4.7,0-8.5,3.8-8.6,8.5v35.8H97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M188.3,30c-2.9,0-5.8,0.8-8.3,2.3v-8.3c-0.1-10.8-8.9-19.5-19.8-19.5H49.7 c-10.9,0-19.7,8.8-19.8,19.7v8.3c-8-4.6-18.2-1.9-22.8,6.1C5.7,41,5,43.8,4.9,46.6v32.2c0,9.6,7.9,17.4,17.5,17.3c0,0,0,0,0,0h7.5 v12c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2v-12h133.3v12c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2v-12h7.5c9.6,0,17.5-7.7,17.5-17.3 c0,0,0,0,0,0V46.6C204.9,37.4,197.5,30,188.3,30z M171.6,24.1v38.7h-62.5v-50h51.1C166.5,12.8,171.6,17.8,171.6,24.1z M38.3,24.1 c0-6.3,5.1-11.3,11.4-11.3h51.1v50H38.3C38.3,62.8,38.3,24.1,38.3,24.1z M196.6,78.8c-0.1,5-4.2,9-9.2,9h-165c-5,0-9.1-4-9.2-9V46.6 c0-4.6,3.7-8.3,8.3-8.3s8.3,3.7,8.3,8.3v20.3c0,2.3,1.9,4.2,4.2,4.2c0,0,0,0,0,0h141.7c2.3,0,4.2-1.9,4.2-4.2v0V46.6 c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3L196.6,78.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.0a821606ea52a7238608dde5214c93d6.svg";
export { ForwardRef as ReactComponent };